<template>
  <Row>
    <Col class="text-right">
      <Button-group v-if="$route.meta.page < 9">
        <Button
          :size="size"
          type="primary"
          icon="ios-arrow-up"
          @click="chgright = 0, itemsSort(itemsAxios)"
        ></Button>
        <Button
          :size="size"
          type="primary"
          icon="ios-arrow-down"
          @click="chgright = 1, itemsSort(itemsAxios)"
        ></Button>
      </Button-group>
    </Col>
    <table class="lida-leading-table mt-1" :class="[cloce]" width="100%" v-if="items.length">
      <thead>
        <th width="10%">序號</th>
        <th width="10%">{{$route.meta.title}}</th>
        <th width="10%">{{$t('lsib.ShengShiau')}}</th>
        <th width="10%">重肖</th>
        <th width="25%">賠率</th>
        <th>占成/均赔</th>
        <th>可赢金额</th>
        <th width="15%" v-if="liveshowPath">建议补货</th>
      </thead>
      <tbody>
        <tr v-for="(it, index) in items" :key="index+'tc3'" class="tc">
          <td>{{ index + Theindex}}</td>
          <td :class="[classColor(it.colour), it.numtarget ? 'targetColor' : '']">
            <h3>{{ it.name }}</h3>
          </td>
          <td :class="it.target ? 'targetColor' : ''">{{it.zodiac}}</td>
          <td>{{it.requyzo}}</td>
          <td>
            <table-adjust-odds :table="it" :betcallistshow="false" :addbetcal="false"></table-adjust-odds>
          </td>
          <td>
            <p>{{ Math.round(it.ltl) | commaFormat }} / {{ liveshowPath ? strip(it.avgtrodds) : avgtroddsDivide(it.avgtrodds) | commaFormat }}</p>
          </td>
          <td>
            <p :class="it.realcal1 > 0 ? 'pc2':'pc1'">{{ Math.round(it.realcal1) | commaFormat }}</p>
          </td>
          <td v-if="liveshowPath">
            <p>{{ Replenished(it.realcal1, it.avgtrodds) | commaFormat}}</p>
          </td>
        </tr>
      </tbody>
    </table>
    <P class="text-center" v-if="$route.meta.page == 1">{{ $t('lsib.TeMaAvgOdds') }}：{{average}}</P>
  </Row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NP from 'number-precision'
import checkpath from 'views/liveshow/mixins/checkPath'
export default {
  name: 'livshow-right-table',
  mixins: [checkpath],
  data () {
    return {
      size: 'small',
      items: [],
      itemsAxios: [],
      avgtrodds: null,
      chgright: 0,
      zodiaclist: [],
      reqyzo: []
    }
  },
  computed: {
    ...mapGetters(['getliveshow', 'getmember', "getpermission", "getgameid"]),
    commonItems () {
      const value = this.items.sort((a, b) => a.realcal1 - b.realcal1)
      return this.chgright == 0
        ? this.items.slice(0, 25)
        : this.items.slice(25, 49)
    },
    Theindex () {
      return this.chgright ? 26 : 1
    },
    average () {
      const result = this.liveshowPath
        ? this.odd1avgodd
        : this.allabgtordds
      return result
    },
    odd1avgodd () { // 計算特碼平均倍率 使用avgtroddData 的 avgtrodds 進行計算。
      const list = this.itemsAxios.filter(it => it.avgtrodds)
      const plusOdds = list.reduce((acc, val) => {
        acc = NP.plus(acc, val.avgtrodds)
        return acc
      }, 0)
      const mathOdds = NP.round(NP.divide(plusOdds, list.length), 2)
      return list.length ? mathOdds : '0.00'
    },
    allabgtordds () {
      if (this.liveshowAllPath && Object.keys(this.getliveshow.topbardata).length && 'periodstate' in this.getliveshow.topbardata) {
        const array = this.getliveshow.topbardata.periodstate
        const amount = array.reduce((acc, val) => {
          acc = NP.plus(acc, val.odd1avgodd == null ? 0 : val.odd1avgodd)
          return acc
        }, 0)
        return this.avgtroddsDivide(amount, this.getliveshow.topbardata.periodstate.length)
      }
    }
  },
  watch: {
    '$route' (to, from) {
      if (this.routerSplit(to.name) != this.routerSplit(from.name)) {
        this.items = []
        this.itemsAxios = []
      }
    },
    'getliveshow.siteSelect' (siteSelect) {
      if (siteSelect == '') {
        this.itemsAxios = []
        this.items = []
      }
    },
    'getliveshow.targetData' (targetData) {
      this.items.forEach(item => {
        let zodiac = this.zodiaclist.find(zodiac => zodiac.number.includes(item.name))
        item.target = zodiac.number.split(',').every(num => targetData.includes(parseInt(num, 10)))
        item.numtarget = targetData.includes(parseInt(item.name, 10))
      })
    },
    getgameid () {
      this.chgright = 0
      this.getBlackreqyzo()
    }
  },
  async created () {
    this.zodiaclist = await this.$axios.liveshow.yzodod()
    this.getBlackreqyzo()
    NP.enableBoundaryChecking(false)
  },
  mounted () {
    this.input = this.getliveshow.topbardata.pm1limit
  },
  methods: {
    ...mapActions(['chg_liveshow_state']),
    async getBlackreqyzo () {
      try {
        const res = await this.$axios.liveshow.blackreqyzo(this.getgameid)
        this.reqyzo = res.blackreqyzo
          ? res.blackreqyzo.split(',')
          : []
      } catch (error) {
        console.error(error);
        return error
      }
    },
    async firstaxios (val) {
      if (!val.length) return
      this.ScodeItems = val
      const meta = this.$route.meta
      const obj = {
        gameid: this.getgameid,
        page: meta.page,
        odd: meta.page == 1 ? "1" : meta.odd,
        baco: this.getliveshow.chgbaco,
        next: this.chgright,
        site: this.getliveshow.siteSelect
      }
      if (this.getliveshow.siteSelect == '') {
        this.itemsAxios = []
        this.items = []
        return
      }
      try {
        const res = this.liveshowPath
          ? await this.$axios.liveshow.supodods(obj)
          : await this.$axios.liveshow.linksupodods(obj)
        if ('status' in res && res.status === 0) return
        if (!Object.keys(res).length) return
        if (this.liveshowAllPath && 'other' in res) {
          this.avgtrodds = res.other[0].count
        }
        this.itemsAxios = this.liveshowPath ? res : res.data
        this.itemsSort(this.itemsAxios)

      } catch (error) {
        console.error(error);
        return error
      }
    },
    itemsSort (value) {
      if (!value) return
      let array = value
      for (let i = 0; i < array.length; i++) {
        const it = array[i];
        for (let x = 0; x < array.length; x++) {
          const res = this.ScodeItems[x];
          if (it.troddid != res.troddid) continue;
          array[i] = Object.assign({}, it, res)
          break;
        }
      }
      array = array.map(it => {
        let zodiac = this.zodiaclist.find(item => item.number.includes(it.name))
        let requyzo = this.reqyzo.findIndex(zodiackey => zodiackey == zodiac.yzorder)
        let target = zodiac.number.split(',').every(num => this.getliveshow.targetData.includes(parseInt(num, 10)))
        let numtarget = this.getliveshow.targetData.includes(parseInt(it.name, 10))
        return {
          ...it,
          zodiac: zodiac.zodiac,
          requyzo: requyzo == -1 ? '-' : requyzo+1,
          target,
          numtarget
        }
      })
      const sortArray = array.sort((a, b) => a.realcal1 - b.realcal1)
      this.items = this.chgright == 0
        ? sortArray.slice(0, 25)
        : sortArray.slice(25, 49)
    },
    indexAdd (value) {
      return value.map((it, i) => {
        const index = this.chgright ? 26 : 1
        it.index = i + index;
        return it;
      })
    },
    Replenished (amout, odds) {
      const pm1limit = this.getliveshow.topbardata.pm1limit
      const realcal1 = NP.strip(amout)
      let result
      if (odds != 0) {
        const mathodds = NP.minus(odds, 1)
        result = NP.divide((realcal1 - pm1limit), mathodds).toFixed(2)
      } else {
        result = 0
      }
      return NP.round(result, 0)
    },
    avgtroddsDivide (value, index) {
      const avgtrodds = NP.strip(value)
      const number = index || this.avgtrodds
      let result = NP.divide(value, number).toFixed(2)
      return result
    },

  }
};
</script>

<style lang="scss">
.targetColor {
  background-color: yellow !important;
}
</style>
